module.exports = __webpack_public_path__ + "img/glasses-02.e2bdf91a.png";